module.exports = __webpack_public_path__ + "5318015957d2c2c66703d5923bf6af5c.svg";